import _objectWithoutProperties from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from "react";
import { Field } from "redux-form"; // import { Field } from 'react-final-form';

import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';

var InputToggle =
/*#__PURE__*/
function (_Component) {
  _inherits(InputToggle, _Component);

  function InputToggle(props) {
    var _this;

    _classCallCheck(this, InputToggle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputToggle).call(this, props));

    _this.renderCheckbox = function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          helperText = _ref.helperText,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          custom = _objectWithoutProperties(_ref, ["input", "label", "helperText", "meta"]);

      return React.createElement(FormControl, {
        component: "fieldset"
      }, React.createElement(FormGroup, null, React.createElement(FormControlLabel, {
        control: React.createElement(Checkbox, {
          size: "medium",
          color: "primary",
          label: label,
          checked: input.value,
          onChange: input.onChange
        }),
        label: label
      })), React.createElement(FormHelperText, null, helperText));
    };

    _this.state = {
      value: props.value
    };
    return _this;
  }

  _createClass(InputToggle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          fieldName = _this$props.fieldName,
          disabled = _this$props.disabled,
          className = _this$props.className,
          label = _this$props.label,
          helperText = _this$props.helperText;
      return React.createElement(React.Fragment, null, React.createElement(Field, {
        component: this.renderCheckbox,
        label: label,
        helperText: helperText,
        name: fieldName,
        disabled: disabled,
        className: className,
        style: disabled ? {
          display: "none"
        } : {
          padding: 0
        },
        context: this.props.context
      }));
    }
  }]);

  return InputToggle;
}(Component);

InputToggle.defaultProps = {
  disabled: true,
  name: null,
  value: null,
  className: null
};
export default InputToggle;